<div [class.button]="button" [style.width]="{width: size !== undefined ? size : 'inherit'}" class="icon-component center-children">
  <svg-icon [style.color]="color" svgClass="center-children" [svgStyle]="size ? {width: size + 'px', height: size + 'px' } : {width: 'inherit' }"
            [src]="getSvgFile(type)"></svg-icon>
</div>

